// Snowflake timestamps without an explicit offset are UTC TIMESTAMP_NTZ values.
const parseUtc = (value) => {
  if (typeof value !== 'string' || !value) return NaN;
  const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`;
  return Date.parse(normalized);
};

export const deadWorker = (claim, now = Date.now()) => {
  const lease = parseUtc(claim?.lease_expires_at);
  if (Number.isFinite(lease)) {
    return now > lease + 90 * 1000
      ? 'The worker for this run stopped reporting, so it is no longer running.'
      : null;
  }
  if (claim?.state !== 'accepted') return null;
  const started = parseUtc(claim?.started_at || claim?.modified_date);
  return Number.isFinite(started) && now > started + 180 * 1000
    ? 'No worker ever picked this run up, so it is not running.'
    : null;
};
